import React, { Component } from "react";
import { Layout } from "antd";
import Filters from "./charts/Filters_articles";
import ArticlesTable from "./charts/Table_articles";

const { Sider, Content } = Layout;

export default class Articles extends Component {
  findAllCategories() {
    var categories = [
      ...new Set(
        this.props.data
          .map((d) => d.categories)
          .join(",")
          .split(",")
      ),
    ];
    var categoriesOptions = [];
    categories.forEach(function (c) {
      var cat = { value: c, label: c };
      categoriesOptions.push(cat);
    });

    return categoriesOptions;
  }

  allCategories = this.findAllCategories();

  maxNumberOfImages = this.props.data.sort(function (a, b) {
    return parseFloat(b["n_images"]) - parseFloat(a["n_images"]);
  })[0]["n_images"];

  constructor(props) {
    super(props);
    this.state = {
      includedImportances: ["Top", "High", "Mid", "Low", "Unknown"],
      includedQualities: [
        "FA",
        "GA",
        "A",
        "B",
        "C",
        "Start",
        "Stub",
        "FL",
        "List",
        "Unassessed",
      ],
      imagesRange: [0, this.maxNumberOfImages],
      categories: this.allCategories.map((a) => a.value),
    };
  }

  changeIncludedImportances = (value) => {
    this.setState({
      includedImportances: value,
    });
  };

  changeIncludedQualities = (value) => {
    this.setState({
      includedQualities: value,
    });
  };

  changeImagesRange = (value) => {
    this.setState({
      imagesRange: value,
    });
  };

  changeCategories = (value) => {
    if (value.length <= 0) {
      this.setState({
        categories: this.allCategories.map((a) => a.value),
      });
    } else {
      this.setState({
        categories: value,
      });
    }
  };

  render() {
    const { includedImportances } = this.state;
    const { includedQualities } = this.state;
    const { categories } = this.state;
    const { imagesRange } = this.state;
    const filteredData = this.props.data
      .filter(
        (article) => includedImportances.indexOf(article.importance) !== -1
      )
      .filter((article) => includedQualities.indexOf(article.quality) !== -1)
      .filter((article) =>
        categories.some((r) => article.categories.includes(r))
      )
      .filter(function (article) {
        var max = Math.max(...imagesRange);
        var min = Math.min(...imagesRange);
        return article.n_images >= min && article.n_images <= max;
      });

    return (
      <Layout>
        <Content
          className="viz-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignContent: "flex-start",
          }}
        >
          <ArticlesTable
            data={filteredData}
            numberOfArticles={this.props.data.length}
          />
        </Content>
        <Sider theme="light">
          <Filters
            maxNumberOfImages={this.maxNumberOfImages}
            allCategories={this.allCategories}
            changeIncludedImportances={this.changeIncludedImportances}
            changeIncludedQualities={this.changeIncludedQualities}
            changeImagesRange={this.changeImagesRange}
            changeCategories={this.changeCategories}
          />
        </Sider>
      </Layout>
    );
  }
}
